export const IFRAME_PATH = '/iframe'

export default function getIframePath (title, url) {
  return `${IFRAME_PATH}?title=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`
}
